import cx from 'classnames';

type Props = {
  className?: string;
  children: React.ReactNode;
  vertical?: boolean;
  horizontal?: boolean;
};

export const CardSectionFullBleed = ({ className, children, vertical, horizontal = true }: Props): JSX.Element => {
  return (
    <div
      className={cx(className, {
        '-mx-32 md:-mx-40': horizontal,
        '-my-32 md:-my-40': vertical,
      })}
    >
      {children}
    </div>
  );
};
